import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewVaultQuestionsPageNew from "../../components/VaultQuestions/ViewVaultQuestionsPageNew";



const ViewVaultQuestionsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Vault Questions" link2="/vault-questions" title="View Vault Question" />

        {/* AddUserLayer */}
        <ViewVaultQuestionsPageNew/>


      </MasterLayout>
    </>
  );
};

export default ViewVaultQuestionsPage;
